<script type="ts">
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
	import { Localized } from '@nubolab-ffwd/svelte-fluent';
    import { Checkbox, Modal, TextInput } from "carbon-components-svelte";

	const { getTranslation } = stores();

    export let open;
    export let canSave;
    export let toSave;
</script>

<Modal
    size="xs"
    bind:open
    modalHeading={$getTranslation("save-title").value}
    primaryButtonText={$getTranslation("save-continue").value}
    secondaryButtonText={$getTranslation("save-cancel").value}
    primaryButtonDisabled={!canSave}
    on:click:button--secondary
    on:open
    on:close
    on:submit
>
    <div class="save-form">
        <TextInput required labelText={$getTranslation("save-firstname").value} bind:value={toSave.firstName} />
        <TextInput required labelText={$getTranslation("save-lastname").value} bind:value={toSave.lastName} />
        <TextInput required labelText={$getTranslation("save-email").value} bind:value={toSave.email} />
        <Checkbox 
            labelText={$getTranslation("save-newsletter-label").value} 
            on:check={v => toSave.newsletter = v.detail}
        />
        <Checkbox 
            labelText={$getTranslation("save-agreement").value} 
            on:check={v => toSave.checked = v.detail}
        />
    </div>
</Modal>